import { css } from 'linaria';
import { styled } from 'linaria/react';

export const AdditionalTextContainer = styled.section`
	width: 100%;
	background-color: var(--background-secondary);
	padding-block: 40px;
`;

export const textStyles = css`
	font-weight: 400;
	font-size: 12px;
	line-height: 16px;
	letter-spacing: 0.2px;
	color: var(--text-secondary);

	h2 {
		font-weight: 500;
		font-size: 20px;
		line-height: 26px;
		letter-spacing: 0.15px;
		color: var(--text-primary);
	}

	h3 {
		margin-block: 16px 8px;
		font-size: 14px;
		line-height: 20px;
	}

	p {
		margin-top: 15px;
	}

	strong {
		font-weight: 500;
		color: var(--text-primary);
	}
`;
